export const GeneType = {
  //dietの遺伝子多型
  UCP1:  { WILD: 4, HETERO: 5, HOMO: 6 },
  ADRB2: { WILD: 7, HETERO: 8, HOMO: 9 },
  ADRB3: { WILD: 1, HETERO: 2, HOMO: 3 },

  //skinの遺伝子多型
  GPX1: { WILD: 31, HETERO: 32, HOMO: 33 },
  SOD2: { WILD: 28, HETERO: 29, HOMO: 30 },
  MMP1: { WILD: 25, HETERO: 26, HOMO: 27 },
  NORESULT: 0,
}

//　ACTN3は肥満タイプで使用される遺伝子名。sportsはACTN3のみ
export function actn3_result(actn3) {
    switch (actn3) {
        case "TT":
            return "slow";
        case "TC":
            return "balance";
        case "CC":
            return "fast";
        default:
            return GeneType.NORESULT;
    }
}

//　UCP1は肥満タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function ucp1_result(ucp1) {
    switch (ucp1) {
        case "AA":
            return GeneType.UCP1.WILD;          
        case "AG":
            return GeneType.UCP1.HETERO;
        case "GG":
            return GeneType.UCP1.HOMO;       
        default:
            return GeneType.NORESULT;           
    }
}

//ADRB2は肥満タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function adrb2_result(adrb2) {
    switch (adrb2) {
        case "AA":
            return GeneType.ADRB2.WILD;            
        case "AG":
            return GeneType.ADRB2.HETERO;           
        case "GG":
            return GeneType.ADRB2.HOMO;
        default:
            return GeneType.NORESULT;
            
    }
}

//ADRB3は肥満タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function adrb3_result(adrb3) {
    switch (adrb3) {
        case "AA":
            return GeneType.ADRB3.WILD;            
        case "AG":
            return GeneType.ADRB3.HETERO;          
        case "GG":
            return GeneType.ADRB3.HOMO;           
        default:
            return GeneType.NORESULT;            
    }
}

//ucp1_result（）メソッドの返却値がwild,hetero,homoなのか返している。
function ucp1_type(ucp1) {
    switch (ucp1_result(ucp1)) {
        case GeneType.UCP1.WILD:
            return "wild";           
        case GeneType.UCP1.HETERO:
            return "hetero";           
        case GeneType.UCP1.HOMO:
            return "homo";           
    }
}

//adrb2_result（）メソッドの返却値がwild,hetero,homoなのか返している。
function adrb2_type(adrb2) {
    switch (adrb2_result(adrb2)) {
        case GeneType.ADRB2.WILD:
            return "wild";           
        case GeneType.ADRB2.HETERO:
            return "hetero";           
        case GeneType.ADRB2.HOMO:
            return "homo";           
    }
}

//adrb3_result（）メソッドの返却値がwild,hetero,homoなのか返している。
function adrb3_type(adrb3) {
    switch (adrb3_result(adrb3)) {
        case GeneType.ADRB3.WILD:
            return "wild";            
        case GeneType.ADRB3.HETERO:
            return "hetero";           
        case GeneType.ADRB3.HOMO:
            return "homo";           
    }
}

//userの多型タイプが２７種類のうちどれに属すか数字で返す。数字にしているのはdietInit（）メソッドでタイプ判別で使用するため。
function dietNum(ucp1, adrb2, adrb3) {
    let checks = [
        ["homo",   "wild",   "homo",   1],
        ["homo",   "wild",   "hetero", 2],
        ["homo",   "wild",   "wild",   3],
        ["hetero", "wild",   "homo",   4],
        ["hetero", "wild",   "hetero", 5],
        ["hetero", "wild",   "wild",   6],
        ["homo",   "homo",   "homo",   7],
        ["homo",   "homo",   "hetero", 8],
        ["homo",   "homo",   "wild",   9],
        ["homo",   "hetero", "homo",   10],
        ["homo",   "hetero", "hetero", 11],
        ["homo",   "hetero", "wild",   12],
        ["hetero", "homo",   "homo",   13],
        ["hetero", "homo",   "hetero", 14],
        ["hetero", "homo",   "wild",   15],
        ["hetero", "hetero", "homo",   16],
        ["hetero", "hetero", "hetero", 17],
        ["hetero", "hetero", "wild",   18],
        ["wild",   "homo",   "homo",   19],
        ["wild",   "homo",   "hetero", 20],
        ["wild",   "homo",   "wild",   21],
        ["wild",   "hetero", "homo",   22],
        ["wild",   "hetero", "hetero", 23],
        ["wild",   "hetero", "wild",   24],
        ["wild",   "wild",   "homo",   25],
        ["wild",   "wild",   "hetero", 26],
        ["wild",   "wild",   "wild",   27],
    ];

    if (adrb3_type(adrb3) && ucp1_type(ucp1) && adrb2_type(adrb2)) {

        return checks.find((item) => {
            if (item[0] == adrb3_type(adrb3) && item[1] == ucp1_type(ucp1) && item[2] == adrb2_type(adrb2) ){
                return true;  
            } 
            return false;
        })[3];
    }
}

//AWSのファイル名で必要ため４タイプのイニシャルを返す。
export function dietInit(border, ucp1, adrb2, adrb3) {
    if (dietNum(ucp1, adrb2, adrb3) == 27) {
        return "i"; //adameve
    } else if (dietNum(ucp1, adrb2, adrb3) == 26 || dietNum(ucp1, adrb2, adrb3) == 25) {
        return "b"; //banana
    } else if (border <= dietNum(ucp1, adrb2, adrb3) && dietNum(ucp1, adrb2, adrb3) <= 24) {
        return "p"; //pear
    } else {
        return "a"; //apple
    }
}
// GPX1は肌タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function gpx1_result(gpx1) {
    switch (gpx1) {
        case "CC":
            return GeneType.GPX1.WILD;       
        case "TT":
            return GeneType.GPX1.HETERO;          
        case "TC":
            return GeneType.GPX1.HOMO;         
        default:
            return GeneType.NORESULT;            
    }
}

// SOD2は肌タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function sod2_result(sod2) {
    switch (sod2) {
        case "GG":
            return GeneType.SOD2.WILD;    
        case "AG":
            return GeneType.SOD2.HETERO;        
        case "AA":
            return GeneType.SOD2.HOMO;      
        default:
            return GeneType.NORESULT;          
    }
}

// MMP1は肌タイプで使用される遺伝子名の一つ。AWSに置かれているファイルを呼び出すために使用する数字を返している。
export function mmp1_result(mmp1) {
    switch (mmp1) {
        case "DD":
            return GeneType.MMP1.WILD;          
        case "II":
            return GeneType.MMP1.HETERO;           
        case "DI":
            return GeneType.MMP1.HOMO;           
        default:
            return GeneType.NORESULT;            
    }
}

export function dietImgs(dietPath) {
    let items = [
        "01.svg",
        "02.svg",
        "03.svg",
        "04.svg",
        "05.svg",
        "06.svg",
        "07.svg",
        "08.svg",
        "09.svg",
        "10.svg",
        "11.svg",
        "12.svg",
        "13.svg",
        "14.svg",
        "15.svg",
        "16.svg",      
    ]

    var arr = items.map((item) => {
        return dietPath + item;
    });
    return arr
}

export function skinImgs(skinPath) {
    let items = [
        "01.svg",
        "02.svg",
        "03.svg",
        "04.svg",
        "05.svg",
        "06.svg",
        "07.svg",
        "08.svg",
        "09.svg",
        "10.svg",
        "11.svg",
        "12.svg",
    ]

    var arr = items.map((item) => {
        return skinPath + item;
    });
    return arr
}

export function sportsImgs(sportsPath) {
    let items = [
        "01.svg",
        "02.svg",
        "03.svg",
        "04.svg",
        "05.svg",
        "06.svg",
        "07.svg",
        "08.svg",
    ]

    var arr = items.map((item) => {
        return sportsPath + item;
    });
    return arr
}


// WEBPACK FOOTER //
// ./src/components/dietSkinSportsUtil.js